import React from "react";
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button
} from "shards-react";
import { toast } from 'react-toastify';
import FeatherIcon from "feather-icons-react";
import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";
import "./InstagramFeed.scss";

@inject(({ teamUser }) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({ common }) => ({ getInstagramFeed: common.getInstagramFeed, getInstagramTaggedFeed: common.getInstagramTaggedFeed }))

@observer
class InstagramFeed extends React.Component {
  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable isLogin = false;
  @observable isLoading = true;

  // 탭
  @observable activeTab = 'myFeed'; // 'myFeed' or 'taggedFeed'

  // Instagram 데이터
  @observable instagramData = {
    connected: false,
    username: "",
    userId: "",
    profilePicture: "",
    followersCount: 0,
    followsCount: 0,
    mediaCount: 0
  };

  @observable feedItems = [];
  @observable selectedMedia = null;
  @observable selectedMediaComments = [];
  @observable showMediaModal = false;

  // 페이지네이션
  @observable currentPage = 1;
  @observable itemsPerPage = 12;
  @observable hasNextPage = false;
  @observable nextCursor = null;

  componentDidMount() {
    this.init();
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};

      // Instagram 연동 정보 및 피드 로드
      await this.loadInstagramData();
    }
  };

  @action
  loadInstagramData = async () => {
    this.isLoading = true;

    try {
      if (this.activeTab === 'taggedFeed') {
        // 내가 태그된 피드
        const params = {
          store_id: this.store._id,
          shopNo: this.teamUser.selShopNo,
          after: this.nextCursor
        };

        await this.props.getInstagramTaggedFeed(params, (res) => {
          console.log('Instagram Tagged Feed Response:', res);

          if(res && res.data) {
            // 프로필 정보 (첫 로드 시에만)
            if(res.data.profile && !this.instagramData.connected) {
              this.instagramData = {
                connected: true,
                username: res.data.profile.username || '',
                userId: res.data.profile.id || '',
                profilePicture: res.data.profile.profile_picture_url || '',
                followersCount: res.data.profile.followers_count || 0,
                followsCount: res.data.profile.follows_count || 0,
                mediaCount: res.data.profile.media_count || 0
              };
            }

            // 피드 아이템
            if(res.data.tagged_media && res.data.tagged_media.data) {
              this.feedItems = res.data.tagged_media.data;
              this.hasNextPage = res.data.tagged_media.paging && res.data.tagged_media.paging.next;
              this.nextCursor = res.data.tagged_media.paging ? res.data.tagged_media.paging.cursors.after : null;
            }
          } else {
            toast.error('Instagram 연동 정보를 불러올 수 없습니다.');
          }
        });
      } else {
        // 내 피드
        const params = {
          store_id: this.store._id,
          shopNo: this.teamUser.selShopNo,
          platform: 'instagram'
        };

        // Instagram 연동 정보 및 피드 가져오기
        await this.props.getInstagramFeed(params, (res) => {
          console.log('Instagram Feed Response:', res);

          if(res && res.data) {
            // 프로필 정보
            if(res.data.profile) {
              this.instagramData = {
                connected: true,
                username: res.data.profile.username || '',
                userId: res.data.profile.id || '',
                profilePicture: res.data.profile.profile_picture_url || '',
                followersCount: res.data.profile.followers_count || 0,
                followsCount: res.data.profile.follows_count || 0,
                mediaCount: res.data.profile.media_count || 0
              };
            }

            // 피드 아이템
            if(res.data.media && res.data.media.data) {
              this.feedItems = res.data.media.data;
              this.hasNextPage = res.data.media.paging && res.data.media.paging.next;
              this.nextCursor = res.data.media.paging ? res.data.media.paging.cursors.after : null;
            }
          } else {
            toast.error('Instagram 연동 정보를 불러올 수 없습니다.');
            setTimeout(() => {
              //window.location.href = '/snsSetting';
            }, 2000);
          }
        });
      }
    } catch (error) {
      console.error('Instagram 데이터 로드 실패:', error);
      toast.error('Instagram 데이터를 불러오는 중 오류가 발생했습니다.');
    } finally {
      this.isLoading = false;
    }
  };

  @action
  loadMoreFeed = async () => {
    if (!this.hasNextPage || this.isLoading) return;

    this.isLoading = true;

    try {
      const params = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo,
        platform: 'instagram',
        after: this.nextCursor
      };

      await this.props.getInstagramFeed(params, (res) => {
        if(res && res.data && res.data.media && res.data.media.data) {
          this.feedItems = [...this.feedItems, ...res.data.media.data];
          this.hasNextPage = res.data.media.paging && res.data.media.paging.next;
          this.nextCursor = res.data.media.paging ? res.data.media.paging.cursors.after : null;
        }
      });
    } catch (error) {
      console.error('더 많은 피드 로드 실패:', error);
      toast.error('피드를 불러오는 중 오류가 발생했습니다.');
    } finally {
      this.isLoading = false;
    }
  };

  @action
  openMediaDetail = (media) => {
    console.log('Media Detail:', media);
    this.selectedMedia = media;
    this.selectedMediaComments = media.comments ? media.comments : [];
    console.log('Media Detail:', this.selectedMediaComments);
    this.showMediaModal = true;
  };

  @action
  closeMediaDetail = () => {
    this.selectedMedia = null;
    this.selectedMediaComments = [];
    this.showMediaModal = false;
  };

  @action
  changeTab = async (tab) => {
    this.activeTab = tab;
    this.feedItems = [];
    this.nextCursor = null;
    this.hasNextPage = false;
    await this.loadInstagramData();
  };

  formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num;
  };

  formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  renderMediaItem = (media, index) => {
    const isVideo = media.media_type === 'VIDEO';
    const isCarousel = media.media_type === 'CAROUSEL_ALBUM';

    return (
      <Col lg="3" md="4" sm="6" key={media.id} className="mb-4">
        <Card className="instagram-media-card" onClick={() => this.openMediaDetail(media)}>
          <div className="media-thumbnail">
            <img
              src={media.media_url || media.thumbnail_url}
              alt={media.caption ? media.caption.substring(0, 50) : 'Instagram post'}
            />
            {isVideo && (
              <div className="media-type-badge">
                <i className="material-icons">play_circle_filled</i>
              </div>
            )}
            {isCarousel && (
              <div className="media-type-badge">
                <i className="material-icons">collections</i>
              </div>
            )}
            <div className="media-overlay">
              <div className="media-stats">
                <span>
                  <i className="material-icons">favorite</i>
                  {media.like_count ? this.formatNumber(media.like_count) : 0}
                </span>
                <span>
                  <i className="material-icons">comment</i>
                  {media.comments_count ? this.formatNumber(media.comments_count) : 0}
                </span>
              </div>
            </div>
          </div>
          <CardBody className="p-2">
            <small className="text-muted d-block text-truncate">
              {media.caption ? media.caption.substring(0, 60) + '...' : '캡션 없음'}
            </small>
          </CardBody>
        </Card>
      </Col>
    );
  };

  render() {
    return (
      <Container fluid className="main-content-container px-4 instagram-feed-page">
        <Row noGutters className="page-header py-4">
          <PageTitle
            title="Instagram 피드"
            subtitle={this.instagramData.username ? `@${this.instagramData.username}` : '내 Instagram 게시물'}
            className="text-sm-left mb-3"
          />
        </Row>

        {/* 탭 */}
        <Row className="mb-3">
          <Col>
            <div style={{display: 'flex', gap: '10px', borderBottom: '2px solid #e1e8ed', paddingBottom: '10px'}}>
              <Button
                theme={this.activeTab === 'myFeed' ? 'primary' : 'light'}
                onClick={() => this.changeTab('myFeed')}
              >
                <FeatherIcon size="16" icon="grid" />&nbsp;&nbsp;내 피드
              </Button>
              <Button
                theme={this.activeTab === 'taggedFeed' ? 'primary' : 'light'}
                onClick={() => this.changeTab('taggedFeed')}
              >
                <FeatherIcon size="16" icon="at-sign" />&nbsp;&nbsp;내가 태그된 피드
              </Button>
            </div>
          </Col>
        </Row>

        {/* 프로필 정보 카드 */}
        {this.instagramData.connected && (
          <Row className="mb-4">
            <Col>
              <Card>
                <CardBody className="p-4">
                  <div className="d-flex align-items-center">
                    {this.instagramData.profilePicture && (
                      <img
                        src={this.instagramData.profilePicture}
                        alt={this.instagramData.username}
                        className="instagram-profile-pic mr-4"
                      />
                    )}
                    <div className="flex-grow-1">
                      <h5 className="mb-2">@{this.instagramData.username}</h5>
                      <div className="d-flex gap-4">
                        <div>
                          <strong>{this.formatNumber(this.instagramData.mediaCount)}</strong>
                          <span className="text-muted ml-1">게시물</span>
                        </div>
                        <div>
                          <strong>{this.formatNumber(this.instagramData.followersCount)}</strong>
                          <span className="text-muted ml-1">팔로워</span>
                        </div>
                        <div>
                          <strong>{this.formatNumber(this.instagramData.followsCount)}</strong>
                          <span className="text-muted ml-1">팔로잉</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Button
                        theme="secondary"
                        size="sm"
                        onClick={() => window.location.href = '/snsSetting'}
                      >
                        <i className="material-icons mr-1" style={{fontSize: '16px', verticalAlign: 'middle'}}>arrow_back</i>
                        SNS 설정으로
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}

        {/* 피드 그리드 */}
        <Row>
          {this.feedItems && this.feedItems.length > 0 ? (
            this.feedItems.map((media, index) => this.renderMediaItem(media, index))
          ) : (
            !this.isLoading && (
              <Col>
                <Card>
                  <CardBody className="text-center p-5">
                    <i className="material-icons" style={{fontSize: '64px', color: '#ccc'}}>image_not_supported</i>
                    <h5 className="mt-3">게시물이 없습니다</h5>
                    <p className="text-muted">Instagram에 게시물을 올려보세요.</p>
                  </CardBody>
                </Card>
              </Col>
            )
          )}
        </Row>

        {/* 더 보기 버튼 */}
        {this.hasNextPage && (
          <Row className="mt-4 mb-4">
            <Col className="text-center">
              <Button
                theme="primary"
                onClick={() => this.loadMoreFeed()}
                disabled={this.isLoading}
              >
                {this.isLoading ? '로딩 중...' : '더 보기'}
              </Button>
            </Col>
          </Row>
        )}

        {/* 미디어 상세 모달 */}
        {this.showMediaModal && this.selectedMedia && (
          <div className="instagram-modal-overlay" onClick={this.closeMediaDetail}>
            <div className="instagram-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close-btn" onClick={this.closeMediaDetail}>
                <i className="material-icons">close</i>
              </button>
              <Row className="h-100">
                <Col lg="8" className="d-flex align-items-center justify-content-center bg-black">
                  {this.selectedMedia.media_type === 'VIDEO' ? (
                    <video
                      src={this.selectedMedia.media_url}
                      controls
                      className="modal-media"
                      autoPlay
                    />
                  ) : (
                    <img
                      src={this.selectedMedia.media_url}
                      alt="Instagram post"
                      className="modal-media"
                    />
                  )}
                </Col>
                <Col lg="4" className="modal-sidebar">
                  <div className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      {this.instagramData.profilePicture && (
                        <img
                          src={this.instagramData.profilePicture}
                          alt={this.instagramData.username}
                          className="modal-profile-pic mr-2"
                        />
                      )}
                      <strong>@{this.instagramData.username}</strong>
                    </div>

                    <div className="mb-3">
                      <p>{this.selectedMedia.caption || '캡션 없음'}</p>
                    </div>

                    <div className="media-info mb-3">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">좋아요</span>
                        <strong>{this.formatNumber(this.selectedMedia.like_count || 0)}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">댓글</span>
                        <strong>{this.formatNumber(this.selectedMedia.comments_count || 0)}</strong>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">게시일</span>
                        <span>{this.formatDate(this.selectedMedia.timestamp)}</span>
                      </div>
                    </div>

                    {/* 댓글 리스트 */}
                    {this.selectedMediaComments && this.selectedMediaComments.length > 0 && (
                      <div className="comments-section mb-3">
                        <h6 className="mb-3">댓글 ({this.selectedMediaComments.length})</h6>
                        <div className="comments-list">
                          {this.selectedMediaComments.map((comment) => (
                            <div key={comment.id} className="comment-item mb-3">
                              <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <div className="d-flex align-items-center mb-1">
                                    <strong className="mr-2">{comment.username}</strong>
                                    <small className="text-muted">
                                      {this.formatDate(comment.timestamp)}
                                    </small>
                                  </div>
                                  <p className="mb-1" style={{fontSize: '14px'}}>{comment.text}</p>
                                  {comment.like_count > 0 && (
                                    <small className="text-muted">
                                      <i className="material-icons" style={{fontSize: '14px', verticalAlign: 'middle'}}>favorite</i>
                                      {' '}{comment.like_count}
                                    </small>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="mt-4">
                      <Button
                        theme="primary"
                        block
                        onClick={() => window.open(this.selectedMedia.permalink, '_blank')}
                      >
                        <i className="material-icons mr-1" style={{fontSize: '16px', verticalAlign: 'middle'}}>open_in_new</i>
                        Instagram에서 보기
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}

        <ModalLoading isLoading={this.isLoading} />
      </Container>
    );
  }
}

export default InstagramFeed;
